export const getStyles = (tabWidth: string) => {
  const styles = {
    root: {
      position: "fixed",
      top: 60,
      bottom: 0,
      right: tabWidth,
      zIndex: 100,
    },
    active: {
      borderRight: `3px solid`,
    },
    icon: {
      fontSize: 24,
      p: 2,
      width: "57px", // border right + width = 60px
    },
  };
  return styles;
};
